export default __webpack_public_path__ + "img/bg_auth-be63c27805c2364870e5127ca9ab184e.png";